import { Icon } from '@components/Icon/Icon';
import { Tooltip } from '@components/Tooltip/Tooltip';
import { ActionButtonContainer } from '../Actions';
import type { BaseActionProps } from '../Actions';
import { useStrings } from '@hooks/useStrings';

export interface ToggleVisibilityActionProps extends BaseActionProps {
  /**
   * Callback when the button is pressed
   */
  onVisibilityChange: (visible: boolean) => void;
  /**
   * If the element is visible or not
   */
  isVisible: boolean;
}

/**
 * ToggleVisibilityAction component
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-togglevisibilityaction--toggle-visibility-action Code documentation}
 *
 * @example
 * <ToggleVisibilityAction isVisible onVisibilityChange={() => {}} description='Copy my text'/>
 */
export const ToggleVisibilityAction = ({
  onVisibilityChange,
  isVisible,
  description,
  className,
}: ToggleVisibilityActionProps): JSX.Element => {
  const { actions } = useStrings();

  const tooltipText = isVisible ? actions.hide : actions.show;

  return (
    <Tooltip text={tooltipText} hideOnClick={false}>
      <ActionButtonContainer
        className={className}
        onClick={() => onVisibilityChange(!isVisible)}
        type="button"
      >
        <Icon
          size="m"
          icon={isVisible ? 'hidden_off' : 'hidden'}
          description={description}
        />
      </ActionButtonContainer>
    </Tooltip>
  );
};
